import APIClient from '@/shared/http/clients/api'
import AccountRepository from '@/shared/http/repositories/access/account'

const APICore = process.env.APIBaseURLCore
const resource = 'audit'

export default {
  findAll (filter = {}, page = 0, size = 20) {
    const params = {
      page,
      size,
      ...filter
    }

    const config = {
      params,
      paramsSerializer: function (params) {
        const searchParams = new URLSearchParams()

        Object.keys(params).forEach(key => {
          const value = params[key]
          if (Array.isArray(value)) {
            value.forEach(item => searchParams.append(key, item))
          } else if (value !== null && value !== undefined) {
            searchParams.append(key, value)
          }
        })

        return searchParams.toString()
      }
    }

    return APIClient.get(`${APICore}/${resource}`, config)
  },

  findById (id) {
    return APIClient.get(`${APICore}/${resource}/${id}`)
  },

  exportToExcel (filter = {}) {
    return APIClient.get(`${APICore}/${resource}/export`, {
      params: filter,
      responseType: 'blob',
      paramsSerializer: function (params) {
        const searchParams = new URLSearchParams()

        Object.keys(params).forEach(key => {
          const value = params[key]
          if (Array.isArray(value)) {
            value.forEach(item => searchParams.append(key, item))
          } else if (value !== null && value !== undefined) {
            searchParams.append(key, value)
          }
        })

        return searchParams.toString()
      }
    })
  },

  async getAuthorInfo (id) {
    try {
      const response = await AccountRepository.GetById(id)
      return response.data
    } catch (error) {
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/http/repositories/auditoria/audit.js